export default {
	SET_PAGE: (state, data) => {
        state.page = {
            ...state.page,
            ...data
        };
    },
    SET_REGISTER: (state, data) => {
        state.register = {
            ...state.register,
            ...data
        };
    },
    SET_PERSONAL_INFO: (state, data) => {
        state.personalInfo = {
            ...state.personalInfo,
            ...data
        };
    },
    SET_LANDING_PAGE_CONTENT: (state, data) => {
        state.landingPageContent = {
            ...state.landingPageContent,
            ...data
        };
    },
    SET_FOOTER_SETTINGS: (state, data) => {
        state.footerSettings = {
            ...state.footerSettings,
            ...data
        };
    },
    // SET_PAYMENT_API: (state, data) => {
    //     state.paymentAPI = {
    //         ...state.paymentAPI,
    //         ...data
    //     };
    // },
    SET_ENTITLEMENT_DETAILS: (state, data) => {
        state.entitlementDetails = {
            ...state.entitlementDetails,
            ...data
        };
    },
    SET_ADDRESS_ENTITLEMENT: (state, data) => {
        state.addressEntitlement = {
            ...state.addressEntitlement,
            ...data
        };
    },
    SET_REGISTER_CONFIRMATION: (state, data) => state.registerConfirmation = { ...state.registerConfirmation, ...data },
    SET_RESEND_CONFIRMATION_EMAIL: (state, data) => state.resendConfirmationEmail = { ...state.resendConfirmationEmail, ...data },
    SET_VALIDATE_EMAIL_RESULT: (state, data) =>{
        state.validateEmailResult = data;
    },
    SET_VALIDATE_EMAIL_ERROR: (state, data) =>{
        state.validateEmailError = data;
    },
    SET_RESET_PASSWORD_RESULT: (state, data) =>{
        state.resetPasswordResult = data;
    },
    SET_RESET_PASSWORD_ERROR: (state, data) =>{
        state.resetPasswordError = data;
    },
    SET_WEBSITE_METADATA : (state, data) => {
        state.websiteMetadata = {...state.websiteMetadata, ...data}
    },
    SET_SERVICE_WORDING : (state, data) => {
        state.serviceWording = {...state.serviceWording, ...data}
    },
    SET_STREET_ABBREVIATIONS : (state, data) => {
        state.streetAbbreviations = {...state.streetAbbreviations, ...data}
    },
    SET_SITE_WORDINGS : (state, data) => {
        state.siteWordingsSettings = {...state.siteWordingsSettings, ...data}
    },
}